import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "select",
  "use": "select-usage",
  "viewBox": "0 0 1376 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1376 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"select\"><defs><style></style></defs><path d=\"M1223.84 11.296l114.688 114.144L454.784 1024 0 571.232l110.88-130.688 343.904 342.304z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol